// extracted by mini-css-extract-plugin
module.exports = {"goBackArrow":"style_goBackArrow__W1FSt"};